module.exports = __webpack_public_path__ + "img/icon_ent.d4e2e5b6.png";